import { IAppTheme } from "../../../types";

export type TCheckboxSize = "sm" | "md";

type TCheckboxStyles = {
    borderColor: string;
    backgroundColor: string;
    checkColor: string;
};

type TCheckboxStylesMap = TCheckboxStyles & {
    hover: TCheckboxStyles;
    disabled: TCheckboxStyles;
    focus: TCheckboxStyles & {
        ringColor: string;
    };
    size: string;
    borderRadius: string;
    checkboxMargin: string;
    checkSize: string;
    checkStrokeWidth: string;
    labelGap: string;
};

export const getCheckboxStyles = (
    theme: IAppTheme,
    size: TCheckboxSize,
    checked: boolean,
    withLabel: boolean
): TCheckboxStylesMap => {
    let styles = {};

    switch (size) {
        case "sm":
            styles = {
                ...styles,
                size: "16px",
                borderRadius: "4px",
                checkSize: "12px",
                checkStrokeWidth: "4px",
                labelGap: "8px",
                checkboxMargin: withLabel ? "2px 0px 0px 0px" : "0px"
            };
            break;
        case "md":
            styles = {
                ...styles,
                size: "20px",
                borderRadius: "6px",
                checkSize: "16px",
                checkStrokeWidth: "3px",
                labelGap: "12px",
                checkboxMargin: "0px"
            };
            break;
        default:
            throw new Error(`Unknown toggle size: ${size}`);
    }

    styles = {
        ...styles,
        ...(checked
            ? {
                  borderColor: theme.v2.colors["primary-1200"],
                  backgroundColor: theme.v2.colors["surface-900"],
                  checkColor: theme.v2.colors["background-primary-base"],
                  hover: {
                      borderColor: theme.v2.colors["border-primary-900"],
                      backgroundColor: theme.v2.colors["surface-800"],
                      checkColor: theme.v2.colors["background-primary-base"]
                  },
                  disabled: {
                      borderColor: theme.v2.colors["surface-100"],
                      backgroundColor: theme.v2.colors["surface-50"],
                      checkColor: theme.v2.colors["text-primary-400"]
                  },
                  focus: {
                      borderColor: theme.v2.colors["border-primary-900"],
                      backgroundColor: theme.v2.colors["surface-800"],
                      checkColor: theme.v2.colors["background-primary-base"],
                      ringColor: theme.v2.colors["surface-100"]
                  }
              }
            : {
                  borderColor: theme.v2.colors["border-primary-100"],
                  backgroundColor: theme.v2.colors["background-primary-base"],
                  checkColor: "transparent",
                  hover: {
                      borderColor: theme.v2.colors["border-primary-300"],
                      backgroundColor: theme.v2.colors["background-primary-base"],
                      checkColor: "transparent"
                  },
                  disabled: {
                      borderColor: theme.v2.colors["border-primary-100"],
                      backgroundColor: theme.v2.colors["surface-50"],
                      checkColor: "transparent"
                  },
                  focus: {
                      borderColor: theme.v2.colors["primary-300"],
                      backgroundColor: theme.v2.colors["surface-base"],
                      checkColor: "transparent",
                      ringColor: theme.v2.colors["surface-100"]
                  }
              })
    };

    return styles as TCheckboxStylesMap;
};
